<template>
  <transition
    name="slide-x-transition"
    mode="out-in"
  >
    <div
      v-visible="show"
      style="min-height: 100%; display: flex"
      :title="$t('activateMultipleContentsTogetherCheckboxTooltip')"
      @click.prevent.stop="content.selected = !content.selected"
    >
      <v-checkbox
        class="pt-0 mt-0"
        color="msr"
        hide-details
        :input-value="content.selected"
        :data-checked="content.selected"
        data-cy="content-selection-checkbox"
      />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    snapToTop: {
      type: Boolean,
      default: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ContentSelectionCheckbox.vue